'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function ($) {
    /**
     * Utility funciton library for Phase Three.
     *
     * While we are no longer using a complex (read: convoluted) custom script
     * library, we do need some utlities to ease some of our more basic
     * funcionalities (e.g., popping up the snackbar). We store those
     * references here to separate them from our views and other
     * components. To manage persistence, we are making the
     * class an extension of jQuery (since we are already
     * loading it).
     *
     * @since 0.0.1
     * @package jQuery
     * @class $.PhaseThree
     * @author Nghiem Tran <nghiem@phasethree.com>
     */
    var hasHash = 'undefined' !== typeof P3GlobalHash;
    var P3Globals = hasHash ? JSON.parse(atob(P3GlobalHash)) : {};
    $.PhaseThree = {

        /**
         * @var bool debug Development/testing environment flag
         * @var object user The current user object
         * @var objet role The current user role
         * @var string timezone Server-set timezone or best guess
         * @var object resource The current resource to cross-reference
         * @var string permit The permission permit key
         */
        globals: P3Globals,
        activeApps: P3Globals.activeApps,
        apps: P3Globals.apps,
        err: P3Globals.err,
        debug: P3Globals.debug,
        domain: P3Globals.domain,
        emailSender: P3Globals.emailSender,
        fileexts: P3Globals.fileexts,
        filetypes: P3Globals.filetypes,
        imgexts: P3Globals.imgexts,
        imgtypes: P3Globals.imgtypes,
        role: P3Globals.role,
        roles: P3Globals.roles,
        roleEditable: P3Globals.roleEditable,
        roleDefault: P3Globals.roleDefault,
        path: P3Globals.path,
        security: P3Globals.security,
        siteName: P3Globals.site,
        siteUrl: P3Globals.siteUrl,
        timezone: P3Globals.timezone,
        theme: P3Globals.theme || {},
        user: P3Globals.user,
        userCount: P3Globals.userCount,
        view: P3Globals.view,
        resource: {},

        /**
         * Manage analytics data during normal use of the portal.
         *
         * Through the course of both everyday use and development, we will be
         * able to make better-informed decisions if we have some data with
         * which to work. Navigational, event, and failure data will all
         * aid in the scheduling of prioritized development.
         *
         * @since 0.2.0
         * @package PhaseThree
         * @class analytics
         */
        analytics: {
            /**
             * @var string code The analytics code for vendor API
             * @var object model An instance of the analytics object
             * @var bool ready Whether or not analytics is ready to go
             */
            code: P3Globals.analytics,
            super: P3Globals.superAnalytics,
            model: null,
            ready: false,
            readyCode: false,
            readySuper: false,
            trackers: [],

            /**
             * Initialize the analytics setup for use.
             *
             * When we run initialization, we check for the required credentials
             * with which to begin the analytics communication highway.
             *
             * @since 0.2.0
             * @method init
             * @param object component An instance of the analytics component
             */
            init: function init(component) {

                // Declare and initialize
                this.readyCode = !!/^(UA|YT|MO)-\d+-\d+$/i.test(this.code);
                this.readySuper = !!/^(UA|YT|MO)-\d+-\d+$/i.test(this.super);

                // If there is no code at all, bail out
                if (!this.readyCode && !this.readySuper) return;

                // If we have either, we assume we are ready
                this.ready = true;

                // Set a refernce to our tracker
                this.model = component;

                // Declare and initialize
                var properties = [];
                var userId = p3.user ? p3.user.ID : 0;
                var options = {
                    debug: false,
                    alwaysSendToDefaultTracker: false
                };

                // If we had a code, set up the references
                if (this.readyCode) {

                    // Add the tracker to the list
                    properties.push({
                        trackingId: this.code,
                        gaOptions: {
                            name: 'local',
                            userId: userId
                        }
                    });

                    // Update our tracker names
                    this.trackers.push('super');
                }

                // If we had a super code, set up the references
                if (this.readySuper) {

                    // Add the tracker to the list
                    properties.push({
                        trackingId: this.super,
                        gaOptions: {
                            name: 'super',
                            userId: userId
                        }
                    });

                    // Update our tracker names
                    this.trackers.push('local');
                }

                // Single and multiple values are handled differently
                if (1 === this.trackers.length) {

                    // Initialize normally
                    this.model.initialize(properties[0].trackingId, {
                        debug: false,
                        gaOptions: {
                            userId: userId
                        }
                    });
                } else {

                    // Initialize our tracker
                    this.model.initialize(properties, options);
                }
            },

            /**
             * Record an event that has taken place.
             *
             * To know how often users create resources or how often attachments
             * are used in a particular app, we can record the interation as an
             * event. Events help us to know which features are heavily used
             * and which could use a bit more UI friendliness.
             *
             * @since 0.2.0
             * @method event
             * @param object args Arguments that define an event
             * @return void
             */
            event: function event(args) {

                // If we are not ready, bail out
                if (!this.ready) return;

                // Declare and initialize
                var category = args.category || '';
                var action = args.action || '';
                var label = args.label || '';
                var value = args.value || '';

                // If we do not have at least a category and action, bail
                if (!category || !action) return;

                // Line up our params
                var params = {
                    category: category,
                    action: action
                };

                // Add optional properties
                if (label) params.label = label;
                if (value) params.value = value;

                // Logroll
                logger('Analytics event: ' + category + ':' + action, 'focus');

                // Run the event tracking
                this.model.event(params, this.trackers);
            },

            /**
             * Retrieve either the given page or a derived one.
             *
             * When we count page views, we assume that the current location is
             * the new page if a page parameter has not been specified.
             *
             * @since 0.2.2
             * @method getPage
             * @param string page The page (or lack thereof)
             * @param bool domain Flag indicating we want the domain
             * @return string Either the mangled parameter or window location
             */
            getPage: function getPage(page, domain) {

                // If no page was provided, use the current window location
                if (!page) {

                    // Create a composite page view
                    page = window.location.pathname + window.location.search;

                    // Ignore view with IDs
                    page = page.replace(/(view\/.*)/, '');
                } else {

                    // Prepend the proper path to the page view
                    page = (p3.path || '') + '/' + page;
                }

                // Determine if we want to add a trailing slash
                var hasSlash = '/' === page.charAt(page.length - 1);
                var hasQuery = -1 !== page.indexOf('?');

                // Add the slash if necessary
                if (!hasSlash && !hasQuery) page += '/';

                // Add the domain to this pageview
                page = window.location.hostname + page;

                // Return whatever page value we could find
                return page;
            },

            /**
             * Register a page view through modal action.
             *
             * There are views on the site that exist inside modals. While the
             * navigation to a new page has not occurred, we want to report
             * such events as a (specialized) page view for our records.
             *
             * @since 0.2.2
             * @method modalView
             * @param string page The page path we want to use
             * @param string key A key that must be included in the page value
             * @return void
             */
            modalView: function modalView(page) {

                // If we are not ready, bail out
                if (!this.ready) return;

                // Logroll
                logger('Analytics modal page view: ' + page, 'focus');

                // Run the event tracking
                this.model.modalview(this.getPage(page), this.trackers);
            },

            /**
             * Register a page view through navigation.
             *
             * When a user goes from one page to another, we want to record the
             * new page view for a proper accounting of user behavior. If no
             * page is provided, we will use the current window location.
             *
             * Note: We set the page here as well so that subsequent events are
             *       tied to the correct page.
             *
             * @since 0.2.0
             * @method pageView
             * @param string page The page path we want to use
             * @param string key A key that must be included in the page value
             * @return void
             */
            pageView: function pageView(page) {

                // If we are not ready, bail out
                if (!this.ready) return;

                // Retrieve the correct page value
                var page = this.getPage(page);

                logger('Analytics page view: ' + page, 'focus');

                // Run the analytics pageview counter
                this.model.set({ page: page }, this.trackers);
                this.model.pageview(page, this.trackers);
            }

        },

        /**
         * Manage asynchronous request calls.
         *
         * Through the course of all our dynamic view conversations between
         * the frontend and the server, we are going to be making a great
         * number of asynchronous requests that need to be processed.
         * Previously, updating all those method calls between the
         * various requests was a nightmare, so we are getting
         * ahead of the curve a bit here by funneling requests
         * into a single method we can easily maintain.
         *
         * @since 0.0.1
         * @package PhaseThree
         * @class async
         */
        async: {
            /**
             * @var string url The AJAX request URL
             * @var string action The action to enact on asynchronous requests
             * @var int user The current user ID
             */
            url: P3Globals.ajaxUrl,
            action: P3Globals.action,
            user: P3Globals.userId,
            busy: false,

            /**
             * Default asynchronous request parameters.
             *
             * Instead of having to if-set-then-set every single value in the
             * entire argument block, it makes a little more sense to just
             * set some default values for everything and be on our way.
             *
             * @since 0.0.1
             * @var object defaults
             */
            defaults: {
                method: 'post',
                dataType: 'json',
                contentType: false,
                processData: false,
                cache: false,
                log: false,
                params: {},
                before: {
                    message: null,
                    color: null,
                    flash: null
                },
                success: {
                    message: null,
                    color: null,
                    callback: null,
                    args: null,
                    flash: null
                },
                failure: {
                    message: null,
                    color: null,
                    callback: null,
                    args: null,
                    flash: null
                }
            },

            /**
             * Make the asynchronous call.
             *
             * Most all of our asynchronous requests are going to be in the
             * form of a posting of data to our ajax filtering mechanism
             * that is set up server side. By allowing for a number of
             * different params to be passed through this method, we
             * can handle most all requests in a single place.
             *
             * @since 0.0.1
             * @method go
             * @param mixed args Arguments to flesh out our request
             * @return void
             * @todo Move parameter processing out of here
             */
            go: function go(args) {
                // Rhinox Maximize!
                var self = this;
                var cls = '';
                var param = null;
                var params = {};

                // Combine our defaults with the arguments
                args = $.extend({}, self.defaults, args);

                // Make sure we have the correct action set
                args.params.action = self.action;

                // We need params to continue
                if ('object' !== _typeof(args.params)) return;

                // Run any routines we have set before running the request
                self.before(args);

                // Use `FormData` to facilitate file uploads
                var formData = new FormData();

                // Insert all of our parameters
                for (var i in args.params) {

                    // Process datatypes differently
                    if ('object' === _typeof(args.params[i])) {

                        // If we are an object, decide what kind of object
                        cls = getClassName(args.params[i]);

                        // We process filelists differently
                        if ('FileList' === cls) {

                            // Iterate through our file list
                            for (var j in args.params[i]) {
                                // Ignore the `length` parameter
                                if ('length' === j) continue;

                                // Save the param
                                param = args.params[i][j];

                                // Try to get a name
                                var name = param.name;

                                // Define the form key
                                var key = i + '[' + j + ']';

                                // Ignore methods and functions
                                if ('object' !== (typeof param === 'undefined' ? 'undefined' : _typeof(param))) continue;

                                formData.append(key, param, name);
                            }

                            // We are done here
                            continue;
                        } else if ('Array' === cls) {

                            // Create object from array
                            var arrayObject = $.extend({}, args.params[i]);

                            // Stringify arrays
                            param = JSON.stringify(arrayObject);
                        } else {

                            // Make sure our blobs have filenames
                            if ('Blob' === cls) {

                                // Save the param
                                param = args.params[i];

                                // Try to get a name
                                var name = param.name;

                                // Append to the form
                                formData.append(i, param, name);

                                // We are finished with this blob
                                continue;
                            }

                            // Handle Files differently
                            if ('File' === cls) param = args.params[i];else param = JSON.stringify(args.params[i]);
                        }
                    } else {

                        // If the param is already a string, leave as is
                        param = args.params[i];
                    }

                    // Keep a record of our processed params for debugging
                    params[i] = param;

                    formData.append(i, param);
                }

                // Add our nonce value to the request
                var security = p3.security || '';
                formData.append('security', security);

                // Update security token if one was provided
                if (args.security) p3.security = security;

                // Add our formdata to our arguments
                args.formData = formData;

                // If we are just debugging, do not actually run the request
                if (args.debug) {
                    logger(params, 'debug');
                    return;
                }

                // Start measuring how long this operation will take
                var start = performance.now();

                // Fire up our request
                var ajx = $.ajax({
                    method: args.method,
                    url: self.url,
                    dataType: args.dataType,
                    data: formData,
                    cache: args.cache,
                    contentType: args.contentType,
                    processData: args.processData,
                    xhr: function xhr() {
                        // Get our XHR settings
                        var settings = $.ajaxSettings.xhr();
                        var handlers = args.handlers || {};
                        var progress = handlers.progress;
                        var test = function test(progress) {
                            var complete = progress.loaded / progress.total;
                            complete *= 100;
                            logger('Uploading: ' + complete.toFixed(2) + '%', 'upload');
                        };

                        // Hey, if we do not have them, do nothing
                        if (!settings.upload || 'function' !== typeof progress) return settings;

                        // Listen to the progress with our new handler
                        settings.upload.addEventListener('progress', progress, false);

                        // Throw back the new settings with listener
                        return settings;
                    },
                    success: function success(data) {

                        // Determine whether or not we have failed
                        var data = data || '';
                        var failed = p3.err === data || 'string' === typeof data && -1 < data.toString().indexOf(p3.err + '::');

                        // Test for specialized reload-requiring errors
                        var isLogout = p3.err + '::logged-out' === data;
                        var isRefresh = p3.err + '::refresh' === data;
                        var isNonce = p3.err + '::noncense' === data;

                        // Register how long it took
                        var end = performance.now();

                        // Log it, baby
                        p3.log(end - start, 'timer');

                        // Refresh on logout, force refresh, and failed nonce
                        if (isLogout || isRefresh || isNonce) window.location.reload();

                        // Check if we have failure return data
                        if (failed) {

                            // Define our failure message
                            var err = 'SOL (System Objective Lost)';
                            self.failure(args, err, data);
                        } else {

                            // Run our success routine
                            self.success(args, data);
                        }
                    },
                    error: function error(xhr, status, err) {

                        // Register how long it took
                        var end = performance.now();

                        // Log it, baby
                        p3.log(end - start, 'timer');

                        // Run our failure routine
                        self.failure(args, err);
                    }
                });

                // Do not process endlessly
                self.abort(ajx);
            },

            /**
             * Run pre-request routines if any were set.
             *
             * We do not know how long a request is going to take, considering
             * the unlimited possibilities of frontend request and backend
             * server response and processing relationships. Sometimes we
             * will want to show the user a visual confirmation fo what
             * they have just initiated to let them know it is on the
             * right track. We carry out those routines here.
             *
             * @since 0.0.1
             * @method before
             * @param object args Request arguments
             * @return void
             */
            before: function before(args) {
                // "Before" data flashes before the request is sent
                var b = {
                    message: args.before.message,
                    color: args.before.color || '',
                    flash: args.before.flash
                };

                // Maybe we want to run a status before we start
                if (b.message) logger(b.message, 'ajax', b.color);

                // Check if want to flash before we start processing
                if ('object' === _typeof(b.flash) && null !== b.flash) {
                    // Make sure we have a flash callback
                    if ('function' === typeof b.flash.callback) b.flash.callback(b.flash);
                }
            },

            /**
             * Run the success routines if any were set.
             *
             * When a request has gone off successfully, there is cause for a
             * celebration. We begin the festivities by sending out a log
             * message to the console to ensure us of the situation. A
             * nanosecond afterwards we check to see if there are any
             * callbacks we need to run or flashes we need to flash.
             *
             * @since 0.0.1
             * @method success
             * @param object args Success arguments
             * @param mixed data Data returned from the server
             * @return void
             */
            success: function success(args, data) {
                // Declare and initialize
                var log = args.log;
                var m = args.mail || null;
                var s = {
                    message: args.success.message,
                    color: args.success.color || '',
                    callback: args.success.callback,
                    args: args.success.args,
                    data: args.success.data,
                    flash: args.success.flash
                };

                // Run a console log for the status
                logger(s.message, 'success', s.color);

                // Display the data if we need to display data
                if (true === log) {
                    console.log(args.params);
                    console.log(data);
                }

                // If we have a success function, let us call it
                if ('function' === typeof s.callback) s.callback(data, s.args, s.data);

                // If want to success flash a message, do it
                if ('object' === _typeof(s.flash)) {
                    // Make sure we have a flash callback
                    if ('function' === typeof s.flash.callback) s.flash.callback(s.flash);
                }

                // If we set a mail function, run it now
                if (null !== m) {

                    // Add the result to the mailer
                    m.response = data;

                    // Run the mailer routine
                    mailer.send(m);
                }
            },

            /**
             * Run the failure routines if any were set.
             *
             * We consider it a great tragedy if an honest asynchronous request
             * should fail. Some poor user is just trying to update one thing
             * or another and is met with frustration and disappointment.
             * Until we can remedy the sitation, the least we can do is
             * let them know. Gently.
             *
             * @since 0.0.1
             * @method failure
             * @param object args Failure arguments
             * @param string err The error message we received
             * @param object data Data returned in response
             * @return void
             */
            failure: function failure(args, err, data) {
                // Declare and initialize
                var data = data || '';
                var log = args.log;
                var type = p3.err;
                var f = {
                    message: args.failure.message,
                    color: args.failure.color || '',
                    callback: args.failure.callback,
                    args: args.failure.args,
                    data: args.failure.data,
                    flash: args.failure.flash
                };

                // Display the data if we need to display data
                if (true === log) console.log(args.params);

                // If we had axuiliary data, explode it out
                if (-1 < data.toString().indexOf(p3.err + '::')) {
                    type = data.split('::')[1] || '';
                    err = type.replace(/\-/g, ' ');
                }

                // Show a failure message in the console
                logger(f.message, 'fail', f.color);

                // Show the actual error message as well
                logger('Error: ' + err, 'fail', f.color);

                // If we have a failure function, let us call it
                if ('function' === typeof f.callback) {
                    // Define return data
                    var params = {
                        type: type,
                        error: {
                            type: type,
                            returned: err,
                            message: f.message
                        }
                    };

                    // Run the failure callback
                    f.callback(params, f.args, f.data);
                }

                // If want to failure flash a message, do it
                if ('object' === _typeof(f.flash)) {
                    // Make sure we have a flash callback
                    if ('function' === typeof f.flash.callback) f.flash.callback(f.flash);
                }
            },

            /**
             * Run the abort routine when the user is navigating away.
             *
             * When navigation between pages in the past, we have noticed some
             * significant slowdown when an active asynchronous request is
             * in the middle of processing. To help alleviate the strain,
             * we are explicitly binding the ajax object to the unload
             * event of our window in an attempt to stop processing
             * when the user is done with the page.
             *
             * @since 1.0.0
             * @method abort
             * @param object ajx The ajax request object with which to listen
             * @return void
             */
            abort: function abort(ajx) {
                // Make sure the element is not empty
                if ('undefined' == typeof ajx) return;

                // Wait for when the page tries to unload
                $(window).on('beforeunload', function () {
                    ajx.abort();
                });
            }
        },

        /**
         * Deal with app-related methods and routines.
         *
         * When apps need to hear from a higher power in processing, we have a
         * single place where we can check reliably. The most common use for
         * this block is checking whether or not an app is active.
         *
         * @since 0.0.6
         * @package PhaseThree
         * @class app
         */
        app: {
            /**
             * @var string active The current active app
             */
            active: '',

            /**
             * Determine if an app is active.
             *
             * If an application is every made inaccessible for disabled by a
             * local use, we must restrict all access to it. We keep a small
             * record of active app keys in the global object.
             *
             * @since 0.0.6
             * @method isActive
             * @param string key The string identifier for an app
             * @return bool True on active, false on inactive
             */
            isActive: function isActive(active, key) {
                // Declare and initialize
                var active = active || [];

                // Let the caller know if the app is active
                return -1 < active.indexOf(key);
            },

            /**
             * Determine if an app is disabled.
             *
             * Adding another layer of complexity to the mix, we allows users to
             * explicitly disable some global apps by way of user permission.
             *
             * @since 0.4.1
             * @method isDisabled
             * @param string key The string identifier for the app
             * @return bool True if disabled, false if not disabled
             */
            isDisabled: function isDisabled(key) {
                // Declare and initialize
                var apps = p3.apps;
                var disabled = false;

                // Iterate through our apps, looking for the key
                for (var i in apps) {

                    // Ignore non-matching iterations
                    if (key !== apps[i].key) continue;

                    // We found it
                    disabled = true === apps[i].disabled;
                }

                // Return our disabled flag
                return disabled;
            }
        },

        /**
         * Handle browser-based calculations and tests.
         *
         * Due to the inconsistencies that exist between browser types and even
         * between browser versions of the same time, there is some utility in
         * being able to check the browser of the current user.
         *
         * @since 0.5.0
         * @package PhaseThree
         * @class browser
         */
        browser: {
            /**
             * @var object navigator The window navigator.
             */
            navigator: window ? window.navigator : {},

            /**
             * Determine the browser type being used.
             *
             * Probably the most useful browser-based test we can perform is to
             * see which browser the current user is using.
             *
             * @since 0.5.0
             * @method getUserAgent
             * @return string The user agent string
             */
            getUserAgent: function getUserAgent() {
                // Declare and initialize
                var agent = this.navigator.userAgent;

                // Return the user agent string
                return agent;
            },

            /**
             * Determine if the current user is confused and using IE/EDGE.
             *
             * If we are being honest, a major component in checking browser is
             * to see if the user is using Internet Explorer and to implement
             * some sort of graceful degrade for a given functionality.
             *
             * @since 0.5.0
             * @method isMisguided
             * @param bool includeEdge Flag indicating pass for EDGE browsers
             * @return bool Flag indicating presence of IE/EDGE
             */
            isMisguided: function isMisguided(includeEdge) {
                // Declare and initialize
                var agent = this.getUserAgent();
                var isIEOld = -1 !== agent.indexOf('MSIE ');
                var isIE11 = -1 !== agent.indexOf('Trident/');
                var isIE = isIE11 || isIEOld;

                // If we do not care about EDGE, return the result here
                if (!includeEdge) return isIE;

                // Here we are triggering on EDGE as well
                return -1 !== agent.indexOf('Edge/') || isIE;
            }
        },

        /**
         * Manipulations and settings dealing with calendar management.
         *
         * When dealing with time and date, we will most likely be utilizing the
         * very thorough "momentjs" library. This class handles any configs we
         * will use over and over, such as calendar output formats
         *
         * @since 0.0.9
         * @package PhaseThree
         * @class calendar
         */
        calendar: {
            /**
             * Retrieve our preferences for calendar output format.
             *
             * Moment has built-in methods for outputting calendar strings based
             * on a reference point such as "Today at 7:30 PM" or whatever. We
             * want some more fine-grain control to maximize the limitations
             * to our layout and whatnot.
             *
             * @since 0.5.0 Allowing formats to be overwritten
             *
             * @since 0.0.9
             * @method getFormats
             * @param object ref The reference point of our output
             * @param object now The reference point of the present
             * @param object formats Any predetermined formats
             * @return object The calendar formats for a relevant reference
             */
            getFormats: function getFormats(ref, now, formats) {
                // Declare and initialize
                var isEleventh = '11:59 pm' === ref.format('h:mm a');
                var isMidnight = '12:00 am' === ref.format('h:mm a');
                var formatting = _extends({
                    sameDay: '[Today,] h:mm a',
                    nextDay: '[Tomorrow,] h:mm a',
                    nextWeek: 'dddd',
                    lastDay: '[Yesterday,] h:mm a',
                    lastWeek: '[Last] dddd',
                    sameElse: 'MM/DD/YYYY'
                }, formats);

                // If the reference time is end of day, do not print time
                if (isEleventh || isMidnight) {
                    formatting.sameDay = '[Today]';
                    formatting.nextDay = '[Tomorrow]';
                    formatting.lastDay = '[Yesterday]';
                }

                // If we are in the same year, do not show year
                if (now.format('YYYY') === ref.format('YYYY')) {
                    formatting.sameElse = 'MMM D';
                }

                // And there we have it - our formats
                return formatting;
            }
        },

        /**
         * File manipulation utilities.
         *
         * A collection of superficial file manipulation functions that help us
         * manipulate and process files. Acts of uploading or interfacing with
         * the server are still handled by th asynchronous methods.
         *
         * @since 0.0.2
         * @package PhaseThree
         * @class file
         */
        file: {
            /**
             * Get a conveninent size identifier for a given byte size.
             *
             * Instead of showing 6851651 bytes or 6851.651 kb, we are going to
             * run some processing and get a file size string relative to the
             * size of the file.
             *
             * @since 0.0.2
             * @method size
             * @param int bytes
             * @return string Relative size identifier
             */
            size: function size(bytes) {
                // If we have no bytes, return nothing
                if (!bytes) return '';

                // Declare and initialize
                var localeArgs = { maximumFractionDigits: 2 };
                var limits = {
                    gb: 1073741824,
                    mb: 1048576,
                    kb: 1024
                };

                // HUGE FILE? WOW!
                if (bytes >= limits.gb) return (bytes / limits.gb).toLocaleString('us', localeArgs) + 'gb';

                // Megabytes? Not bad.
                if (bytes >= limits.mb) return (bytes / limits.mb).toLocaleString('us', localeArgs) + 'mb';

                // About a normal file, fine.
                if (bytes >= limits.kb) return (bytes / limits.kb).toLocaleString('us', localeArgs) + 'kb';

                // Teeny. Itsy bitsy.
                if (bytes > 1) return bytes + ' bytes';

                // There was probably a problem uploading
                if (bytes == 1) return bytes + ' byte';

                // Throw back the size identifier if we make it here
                return 'unknown size';
            },

            /**
             * Convert a canvas element to a file.
             *
             * When we perform on-screen modifications to images, we will most
             * certainyl utilize canvas elements to build what we need. The
             * caveat to this is that you cannot upload or save canvas
             * elements without first converting them to data URIs
             * and then finally to blobs.
             *
             * Note: There is a `toBlob()` method that can be used directly on
             * canvas elements, but it is probably too new to utilize.
             *
             * @since 0.0.4
             * @method toBlob
             * @param object data The data element to bloberate
             * @param string name The filename to use with the blob
             * @return object New blob object from canvas
             */
            toBlob: function toBlob(data, filename) {
                // Declare and initialize
                var name = filename || 'blob';
                var bytes = atob(data.split(',')[1]);
                var type = { type: '' };
                var array = [];
                var ext = /(?:\.([^.]+))?$/.exec(filename)[1];
                var types = {
                    jpeg: 'image/jpeg',
                    jpg: 'image/jpg',
                    png: 'image/png',
                    gif: 'image/gif',
                    svg: 'image/svg+xml'
                };

                // If it is not an image file, do nothing
                if (!(ext in types)) return null;

                // Set the file type
                type.type = types[ext];

                // Set the array length so we do not have to push
                array.length = bytes.length;

                // Iterate our bytes
                for (var i = 0; i < bytes.length; i++) {
                    array[i] = bytes.charCodeAt(i);
                }

                // Form our unsigned integer array
                var unsigned = [new Uint8Array(array)];

                // Create and return a new blob
                var blob = new Blob(unsigned, type);

                // Escape our filename
                name = name.replace(/[^a-z0-9\.]/gi, '_').toLowerCase();

                // Set a file name
                blob.name = name;

                // Return the almighty blob
                return blob;
            }
        },

        /**
         * Flood control for routines.
         *
         * Actions such as submitting a form or drawing large tracts of data
         * can be very taxing on the server load, depending on the context.
         * A common measure we take to alleviate the potential load is to
         * trap the calls inside our floodgates. We set a timeout that
         * is checked every time a similar action is called and we
         * clear that timeout if the same action is called before
         * the last one completes. In this way we prevent the
         * browser from crashing and burning as well.
         *
         * @since 0.0.1
         * @package PhaseThree
         * @class flood
         */
        flood: {
            /**
             * Maintain record of flood gates.
             *
             * In the spirit of generalization and flexibility while preserving
             * the nature of statefulness and scope, we store all instances
             * of flooding in a single property. We reference them with
             * parameters.
             *
             * @since 0.0.1
             * @var object gates
             */
            gates: {},

            /**
             * Clear the timeout for a given text gate if it was set.
             *
             * At the start of every flood-controlled action, we first attempt
             * to clear out the previously set floodgate by first making sure
             * the timeout set for the action is cleared. An identifying id
             * parameter must be sent through in order to properly clear
             * the original timeout.
             *
             * @since 0.0.1
             * @method clear
             * @param string gate
             * @return void
             */
            clear: function clear(gate) {
                // Rhinox Maximize!
                var self = this;

                // Make sure we have a great to reference
                if (!gate || !(gate in self.gates)) return;

                // I hope that clears up
                clearTimeout(self.gates[gate]);
            },

            /**
             * Implement a flood gate with a given key.
             *
             * When we set a timeout, we wait for little bit before execution
             * in order to account for the situation when the initialization
             * of an action is enacted by a button press. We do not want a
             * database call to occur every time the button is pressed it
             * the user is just absent-mindedly double- or triple-click
             * triggering. The wait time is often undiscernable for a
             * user but may make all the difference for our server.
             *
             * Additionally, we store the created `setTimeout` instance in a
             * variable so we can properly clear and reset when needed.
             *
             * @since 0.0.1
             * @method set
             * @param string gate An identifier for referencing the gate
             * @param function funk The function to enact after waiting
             * @param int interval The amount of time we will wait
             * @return void
             */
            set: function set(gate, funk, interval) {
                // Rhinox Maximize!
                var self = this;

                // If no interval was set, define one that seems reasonable
                if (0 !== interval && !interval) interval = 250;

                // If no gate was passed, make a dangerous unreliable one
                if (!gate) gate = 'gate-' + interval;

                // Attempt to clear the flood first
                self.clear(gate);

                // Set the timeout and define our gate reference
                self.gates[gate] = setTimeout(funk, interval);
            }
        },

        /**
         * Manage various utility handlers.
         *
         * When we want to tie or circumvent certain events or triggers from
         * activating, we can feed our preset handlers to the components in
         * question. The catalyst for this object was the need to handle
         * unsupported "tab" key pressed.
         *
         * @since 0.0.10
         * @package PhaseThree
         * @class handle
         */
        handle: {
            /**
             * Prevent tabbing from one element to the next.
             *
             * When the user hits the tab key, sometimes it reshuffles our view
             * in a way that breaks the layout. We listen for the tab key here
             * and, if we find it, we prevent the default tab action.
             *
             * @since 0.0.10
             * @method tab
             * @param object e The synthetic event object
             * @return void
             */
            tab: function tab(e) {
                // Declare and initialize
                var target = e.currentTarget;
                var key = e.key;

                // If we hit the tab key, do nothing
                if ('Tab' === key) return e.preventDefault();
            }
        },

        /**
         * Manage e-mail send initialization.
         *
         * Instead of tying the mail send requests in the backend where it would
         * be handled by a procedural routine, we make a call for it on the
         * front end asynchronously. Handling the mail send in the backend
         * in sequence relies too heavily on everything going right in
         * order to not disrupt the user experience. If the send were
         * to not complete, the user would be stuck.
         *
         * We use this as a wrapper for a specialized call to the primary async
         * function utility.
         *
         * @since 0.0.2
         * @package PhaseThree
         * @class mail
         */
        mail: {

            /**
             * Initiate the send request.
             *
             * The mail send is generally accessed by the `success` method of
             * the `async` class. Attaching our send methods to the end of
             * successful requests saves us a lot of redundant request
             * result checking and also allows us to know exactly at
             * which point our mail is being sent.
             *
             * @since 0.0.2
             * @method send
             * @param object mail The argument data for a mail send
             * @return void
             */
            send: function send(mail) {
                // Declare and initialize
                var resource = mail.resource;
                var routine = mail.routine || 'sendMail';
                var resourceId = mail.resourceId;
                var type = mail.type || 'update';
                var data = mail.data || {};
                var response = mail.response;
                var log = true === mail.log;
                var gate = ['mail', resource, type, resourceId];
                var args = {
                    log: log,
                    params: {
                        resource: resource,
                        routine: routine,
                        resourceId: resourceId,
                        type: type,
                        data: data,
                        response: response
                    },
                    before: {
                        message: 'Sending a new ' + type + ' email.'
                    },
                    success: {
                        message: type + ' mail successfully sent.'
                    },
                    failure: {
                        message: 'Could not send ' + type + ' email.'
                    }
                };

                // Run the mailer after a delay
                p3.flood.set(gate.join('-'), function () {
                    p3.async.go(args);
                }, 500);
            }

        },

        /**
         * Generate an app link.
         *
         * Since our policies on trailing slashes, URL parts, and the way we
         * handle domains may change in the future, we are going to funnel
         * all of our in-app link handling to a single method.
         *
         * @since 0.0.10
         * @method link
         * @param string uri The resource identfier for our link
         * @param string query Any query variables to append
         * @return string The properly-formed routing link
         */
        link: function link(uri, query) {
            // Declare and initialize
            var path = p3.path;
            var uri = uri || '';
            var query = query ? '?' + query.replace(p3.path, '') : '';

            // If no URI was given, return just the path
            if (!uri.length) return path + '/' + query;

            // Remove the first and last slashes in a URI
            uri = uri.trim().replace(/^\/|\/$/g, '');

            // Otherwise, join the path and URI together
            return path + '/' + uri + '/' + query;
        },

        /**
         * Generic object utility methods.
         *
         * Javascript has a number of rather verbose functions when handling an
         * object or group of objects. Additionally, the spec for dealing with
         * object types (read: class names) is not very good, with `typeof`
         * returning "object" for every type of object. Our class here
         * contains a number of utility methods and routines to help
         * ease the uncertainty of object types.
         *
         * @since 0.0.1
         * @package Phase Three
         * @class object
         */
        object: {
            /**
             * Return the number of single-level properties that exist.
             *
             * Whereas data of type array have a number of useful mechanisms
             * that count the elements therein, objects do not. We then use
             * a simple for loop to count how many properties make up the
             * given level of an object.
             *
             * @since 0.2.1
             * @method count
             * @param object obj The object we will count
             * @return int The numberic representation of the property count
             */
            count: function count(obj) {
                // Do not try to count non-objects
                if ('object' !== (typeof obj === 'undefined' ? 'undefined' : _typeof(obj))) return 0;

                // This seems to be the fastest method
                return Object.keys(obj).length;
            },

            /**
             * Retrieve the name a of a given class object.
             *
             * One of the most essential comparison checks we can perform on an
             * object is to check the type of object with which we are working
             * currently. We are running a native method to discover and are
             * using this method as a wrapper function.
             *
             * @since 0.0.1
             * @method getClassName
             * @param object obj The object we would like to know more about
             * @return string The class name of the object
             */
            getClassName: function getClassName(obj) {
                // Define the return name
                var name = Object.prototype.toString.call(obj);

                // Get a better representation of the class name
                name = name.slice(8, -1);

                // Call it out
                return name;
            },

            /**
             * Generate a lookup object based on array data.
             *
             * While array data have their myriad uses, it is certainly faster
             * to maintain a lookup table one time to reference an item by ID
             * rather than iterating through the entire array each time.
             *
             * @since 0.5.0 Providing flag to store only the index
             *
             * @since 0.0.9
             * @method getLookup
             * @param object arr The array source
             * @param bool index Flag designating storage of index only
             * @return object The lookup table
             */
            getLookup: function getLookup(arr, index) {
                // Declare and initialize
                var array = arr || [];
                var lookup = {};

                // Iterate through the array, defining our lookup
                array.map(function (a, i) {

                    // Get some kind of ID
                    var id = a.id || a.ID || a.term_id || a.key;

                    // Compound the lookup
                    lookup[id] = index ? i : a;
                });

                // Return our lookup table
                return lookup;
            },

            /**
             * Generate a lookup object array based on array data.
             *
             * Similar to the simple lookup generator, here is where we are able
             * to group the objects into arrays that are stored in the result.
             *
             * @since 0.1.1
             * @method getLookupArray
             * @param object arr The array source
             * @param string key The key with which to define a lookup
             * @param bool multi Flag designating multiple keys
             * @return object The lookup table
             */
            getLookupArray: function getLookupArray(arr, key, multi) {
                // Declare and initialize
                var array = arr || [];
                var lookup = {};

                // Iterate through the array, defining our lookup
                array.map(function (a, i) {

                    // Get some kind of ID
                    var id = a[key] || a.id || a.ID || a.term_id || a.key;

                    // Add the original index to the object
                    a.originalIndex = i;

                    // If we are serving multiple keys, iterate them
                    if (multi && 'object' === (typeof id === 'undefined' ? 'undefined' : _typeof(id))) {

                        // Iterate through keys, compounding set
                        id.map(function (k, j) {

                            // Create the property if it does not exist
                            if (!(k in lookup)) lookup[k] = [];

                            // Compound the lookup
                            lookup[k].push(a);
                        });
                    } else {

                        // Create the property if it does not exist
                        if (!(id in lookup)) lookup[id] = [];

                        // Compound the lookup
                        lookup[id].push(a);
                    }
                });

                // Return our lookup table
                return lookup;
            },

            /**
             * Spread an object element between existing object elements.
             *
             * Due to the nature of our element objects being stored as object
             * instances, a simple join will not work. Instead, we need to go
             * through the array and add object elements if we want to use
             * something such as, say, a comma-separated list.
             *
             * @since 0.0.10
             * @method intersperse
             * @param array objects The group of objects
             * @param object|mixed agent The interspertion agent
             * @param bool addKey Flag to add a key to the agent
             * @return An augmented version fo the original array
             */
            intersperse: function intersperse(objects, agent, addKey) {
                // Declare and initialize
                var objects = objects || [];
                var count = objects.length;

                // If there are no objects, bail out
                if (1 > count) return [];

                // Iterate through our object and inject the agent
                while (--count) {

                    // If we want to add a key (for rendering), do so
                    var element = !addKey ? agent : _react2.default.createElement(
                        'span',
                        { key: 'agent-' + count },
                        agent
                    );

                    // Inject our agent element
                    objects.splice(count, 0, element);
                }

                // Return the augmented objects array
                return objects;
            }
        },

        /**
         * Manage permission authorization.
         *
         * We are moving our permission management to the front end so that we
         * might be able to test permissions on-the-fly. Instead of having to
         * rely on synchronization of frontend and backend values we are
         * going to define our permissions once when the page loads.
         *
         * Note: Permissions will be blank for everyone initially - once the
         * main component loads permissions, elevated capability actions
         * will become available to authorized users.
         *
         * @since 0.0.2
         * @package PhaseThree
         * @class permission
         */
        permission: {
            /**
             * @var object permissions Set of permissions from request
             * @var array callbacks Stackable callbacks to stagger loading
             * @var object user The user definition block
             */
            permissions: {}, callbacks: {}, user: {},

            /**
             * Send off for the app permissions.
             *
             * This method should be called by the main component in its initial
             * method (usually `constructor`). After this request completes we
             * begin to open up actions that require permissions (if valid).
             *
             * @since 0.0.7 In order for components that need permissions for
             *              the same resource, we are stacking callbacks and
             *              executing them all at one time on success.
             *
             * @since 0.0.2
             * @method get
             * @param object args Data for requesting permissions
             * @param function callback Any callback handlers after the request
             * @return void
             */
            get: function get(args, callback) {
                // Declare and initialize
                var resource = args.resource;
                var permit = args.permit || resource || 'resource';
                var routine = args.routine || 'getPermissions';
                var user = args.user || {};
                var callbacks = p3.permission.callbacks[resource] || [];
                var hasCallback = 'function' === typeof callback;
                var gate = 'permissions-' + permit;

                // Set our user for the permissions
                p3.permission.user = user;

                // If we do not have a resource, bail out
                if (!resource) return;

                // Create the record if it does not exist
                p3.permission.callbacks[resource] = callbacks;

                // Add the callback to our callback stack
                callbacks.push(callback);

                // Existing callbacks mean we are waiting for the result
                if (hasCallback && 1 < callbacks.length) return;

                // Run the request through a flood gate
                p3.async.go({
                    params: {
                        resource: resource,
                        routine: routine
                    },
                    before: {
                        message: 'Requesting permissions for: ' + resource
                    },
                    success: {
                        message: 'Received permissions for: ' + resource,
                        callback: function callback(data) {

                            // Set our permissions
                            p3.permission.permissions[permit] = data;

                            // Run the callback if we have one
                            if (0 < p3.permission.callbacks[resource].length) for (var i = 0; i < callbacks.length; i++) {

                                // Ignore non-callable values
                                if ('function' !== typeof callbacks[i]) continue;

                                // Run the callback here
                                callbacks[i](data);
                            }

                            // Reset our callbacks for this resource
                            p3.permission.callbacks[resource] = [];
                        }
                    },
                    failure: {
                        message: 'Permission get failed for: ' + resource
                    }
                });
            },

            /**
             * Retrieve the read permissions for use by the server.
             *
             * While a majority of permission tests occur on the frontend in
             * real time, there are still a number of instances where we
             * need to apply permisions in the backend. When we query
             * for resources, for instance, we need to apply the
             * "read permissions to pull in correct results.
             *
             * The return object includes the permissions type (global, own,
             * group, etc.) and auxiliary information (user groups, meta,
             * terms, etc.)
             *
             * @since 0.0.2
             * @method getRead
             * @param string permit The permit key for permissions
             * @param object data Extra data needed for proper query
             * @param string type The permission set to use
             * @return object Read permissions definition block
             */
            getRead: function getRead(permit, data, type) {
                // Declare and initialize
                var data = data || {};
                var p = p3.permission;
                var user = p.user || {};
                var permissions = p.permissions[permit] || {};
                var type = 'string' !== typeof type ? 'read' : type;
                var permits = permissions[type || 'read'] || {};
                var type = 'none';
                var aux = {
                    own: data.own || {},
                    group: data.group || {}
                };
                var sets = {
                    global: {
                        global: permits.global,
                        others: permits.others
                    },
                    own: { global: permits.own },
                    group: { global: permits.group }
                };

                // If we have global read, we are all done
                if (p.hasGlobal(sets.global)) return { type: 'global' };

                // Test for our non-global permissions
                var hasOwn = p.hasGlobal(sets.own);
                var hasGroup = p.hasGlobal(sets.group);

                // Add the groups to which the user belongs
                aux.group.groups = user.groups;

                // Change up our return based on the non-global combination
                if (hasOwn && hasGroup) type = 'own-and-group';
                if (hasOwn && !hasGroup) type = 'own';
                if (!hasOwn && hasGroup) type = 'group';

                // If we do not have any permissions, say so
                return { type: type, aux: aux, userId: user.ID };
            },

            /**
             * Determine if a user has global permissions for a resource.
             *
             * In checking for a global permission, we need only confirm that
             * the user in question has the capability filed under their
             * respective role.
             *
             * @since 0.0.2
             * @method hasGlobal
             * @param object set The permission set to inspect
             * @return bool Flag specifying global permission state
             */
            hasGlobal: function hasGlobal(set) {
                // Declare and initialize
                var p = p3.permission;
                var user = p.user || {};
                var role = user.roleObject || {};
                var global = set.global;
                var others = set.others;
                var permissions = role.permissions || [];
                var hasGlobal = permissions.indexOf(global) > -1;
                var hasOthers = permissions.indexOf(others) > -1;
                var isAdmin = 'administrator' === role.name;

                // We will take either
                return hasGlobal || hasOthers || isAdmin;
            },

            /**
             * Determine if a user has permissions for resources they own.
             *
             * When dealing with "own" permissions, we consider a resource to
             * belong to a user if one of the two following conditions is
             * met: 1) The user authored the resource, or 2) the user is
             * responsible for the resource (i.e., assigned to it).
             *
             * @since 0.0.2
             * @method hasOwn
             * @param object set The permission set to inspect
             * @param resource The current active resource
             * @return bool Flag specifying ownership permission state
             */
            hasOwn: function hasOwn(set, resource) {
                // Declare and initialize
                var p = p3.permission;
                var user = p.user || {};
                var role = user.roleObject || {};
                var permissions = role.permissions || [];
                var own = set.own;
                var userId = +user.ID;
                var hasOwn = permissions.indexOf(own) > -1;
                var author = +(resource.post_author || 0);
                var assigned = resource.assigned || {};
                var assignee = +(assigned.ID || 0);
                var isAuthor = userId === author;
                var isAssigned = userId === assignee;

                // User has to have the permissions and own the resource
                return hasOwn && (isAuthor || isAssigned);
            },

            /**
             * Determine if a user has groups that match those of a resource.
             *
             * Groups can be tied to both users and resources; when attempting
             * to check permissions based on group membership, we reference
             * the groups to which the user belongs and those that were in
             * turn tied to the resource. If there is an overlap in the
             * union, we asset permission to be granted.
             *
             * @since 0.1.1 We are temporarily checking for "hasRole" here until
             *              we are able to hash out a more concrete pattern.
             *
             * @since 0.0.2
             * @method hasGroup
             * @param object set The permission set to inspect
             * @param role The current user role
             * @return bool Flag specifying matching group permission state
             */
            hasGroup: function hasGroup(set, resource) {
                // Declare and initialize
                var p = p3.permission;
                var user = p.user || {};
                var role = user.roleObject || {};
                var group = set.group;
                var permissions = role.permissions || [];
                var hasGroup = permissions.indexOf(group) > -1;
                var userGroups = (user.groups || []).slice();
                var resourceGroups = resource.groups || resource.tags || [];
                var hasRole = false;
                var groupIds = [];
                var intersection = [];

                // If the user does not have the permission, we are done
                if (!hasGroup) return false;

                // Cheat here and check for role
                if (resource.roles && resource.roles.length) {
                    if (resource.roles.indexOf(role.name) > -1) return true;
                }

                // Make sure we do not destroy resource groups
                resourceGroups = resourceGroups.slice();

                // If there are no groups one way or the other, bail
                if (!userGroups.length || !resourceGroups.length) return false;

                // Extrapolate the groups from the user groups
                for (var i in resourceGroups) {

                    // Account for both basic IDs and full object groups
                    if ('object' === _typeof(resourceGroups[i])) groupIds.push(resourceGroups[i].term_id);else groupIds.push(resourceGroups[i]);
                }

                // Sort our arrays
                userGroups.sort(function (a, b) {
                    return a - b;
                });
                groupIds.sort(function (a, b) {
                    return a - b;
                });

                /**
                 * This is pretty neat but I should probably make a note of how
                 * it works. Essentially, we are popping off one element from
                 * each dataset to find matching sets.
                 *
                 * Since the datasets are sorted, we can reliably assume that
                 * going down the ladder will safely remove mismatched value
                 * elements.
                 *
                 * Note: This only works with numeric values (I think)
                 *
                 * @since 0.0.2
                 */
                while (userGroups.length > 0 && groupIds.length > 0) {
                    if (userGroups[0] < groupIds[0]) {
                        userGroups.shift();
                    } else if (userGroups[0] > groupIds[0]) {
                        groupIds.shift();
                    } else {
                        var match = userGroups.shift();
                        intersection.push(match);
                    }
                }

                // If there were any intersections, permission is granted
                return intersection.length > 0 || hasRole;
            },

            /**
             * Determine if the user is able to perform some action.
             *
             * When a request is made to determine authorization of a user for
             * an action, we run it through this function. We iterate through
             * the proper permission block and run a battery of tests to see
             * if the current user qualifies for any of them.
             *
             * @since 0.0.2
             * @method can
             * @param string permit The permit key for permissions
             * @param string act The action or view in question
             * @param object resource The active resource to check
             * @return bool True on authorized, false on unauthorized
             * @todo Reorder checks to optimize performance
             */
            can: function can(permit, act, resource) {
                // Declare and initialize
                var resource = resource || {};
                var p = p3.permission;
                var user = p.user || {};
                var role = user.roleObject || {};
                var datapool = p.permissions[permit] || {};
                var permissions = datapool[act] || false;
                var exists = false !== permissions;
                var action = (act + '').replace('_', ' ');
                var isAdmin = 'administrator' === role.name;
                var hasGlobal = p.hasGlobal(permissions);
                var hasOwn = p.hasOwn(permissions, resource);
                var hasGroup = p.hasGroup(permissions, resource);
                var can = isAdmin || hasGlobal || hasOwn || hasGroup;
                var showLog = false;

                // If we do not want the log, return the result
                if (!showLog) return exists && can;

                // Logroll
                logger('Checking Permissions: ' + action, 'permit');
                if (isAdmin) logger('Is Admin', 'permit');
                if (hasGlobal) logger('Has Global: ' + action, 'permit');
                if (hasOwn) logger('Has Own: ' + action, 'permit');
                if (hasGroup) logger('Has Group: ' + action, 'permit');
                if (!can) logger('Permission Denied: ' + action, 'permit');

                // Any true test grants permission
                return exists && can;
            }
        },

        /**
         * Screen viewport reporting utilities.
         *
         * In terms of user screen size, sometimes we need to know the details
         * of the viewport in order to make informed decisions. Changing up
         * markup for mobile, for instance, is given the greenlight here.
         *
         * @since 0.0.2
         * @package PhaseThree
         * @class viewport
         */
        viewport: {
            /**
             * @var object dimensions Viewport size calculations
             */
            dimensions: {},

            /**
             * Determine if a given element is in view.
             *
             * Due purely to superficial resquirements in user experience, there
             * are times when it is handy to know whether or not an element is
             * in view before we run some handler or other.
             *
             * @since 0.1.1
             * @method visible
             * @param object ele The element in question
             * @param bool debug Flag for loggin debug info
             * @return object Visibility indicators
             * @link https://stackoverflow.com/questions/123999
             */
            elementIsVisible: function elementIsVisible(ele, debug) {
                // Declare and initialize
                var rec = ele.getBoundingClientRect();

                // Define our window calculations
                var win = {
                    w: window.innerWidth,
                    h: window.innerHeight,
                    o: window.pageYOffset
                };

                // Define our document calculations
                var doc = {
                    w: document.documentElement.clientWidth,
                    h: document.documentElement.clientHeight
                };

                // Try to store definitive viewport values
                var vp = {
                    width: win.w || doc.w,
                    height: win.h || doc.h,
                    top: win.o
                };

                // Define a "bottom" view for the viewport
                vp.bottom = vp.top + vp.height;

                // Map out conditions for visibility
                var topOnly = rec.top > 0 && rec.top < vp.bottom && rec.bottom > vp.bottom;

                var bottomOnly = rec.bottom > 0 && rec.bottom < vp.bottom && rec.top < vp.top;

                var middle = rec.top < 0 && rec.bottom > vp.height;

                var full = rec.top > 0 && rec.top < vp.bottom && rec.bottom > 0 && rec.bottom < vp.bottom;

                // If we want debug values, go for it
                if (debug) {

                    // Display viewport and rectangle values
                    console.log(vp);
                    console.log(rec);

                    // Display visibility values
                    console.log({
                        top: topOnly,
                        bot: bottomOnly,
                        mid: middle,
                        all: full
                    });
                }

                // Return visibility indicators
                return {
                    top: topOnly,
                    bottom: bottomOnly,
                    middle: middle,
                    full: full,
                    any: topOnly || bottomOnly || middle || full
                };
            },

            /**
             * Determine if the user has a mobile-sized viewport.
             *
             * There are some styles which are based on the size of the viewport
             * in terms of mobile responsiveness and whatnot. The `viewport-`
             * sizes  include the scrollbars in sizing where the `client-`
             * dimensions do not. The `client-` measurements have greater
             * compatibility across multiple browsers but we also want
             * the most accurate measures available.
             *
             * @since 0.0.2
             * @method getDimensions
             * @return object Definition block for viewport detailsF
             */
            getDimensions: function getDimensions() {
                // Declare and initialize
                var viewportWidth = window.innerWidth || 0;
                var viewportHeight = window.innerHeight || 0;
                var clientWidth = document.documentElement.clientWidth;
                var clientHeight = document.documentElement.clientHeight;
                var width = Math.max(viewportWidth, clientWidth);
                var height = Math.max(viewportHeight, clientHeight);
                var breakpoint = 100;
                var orientation = width > height ? 'portrait' : 'landscape';

                /**
                 * We are using a breakpoints system based on a numeric index.
                 * Instead of testing for "large" or "small", we can just
                 * account for any value below a threshold. This way, we
                 * are not bound to hard limits with any viewport size
                 *
                 * Naming conventions will lead to a pure percentage-based
                 * breakpoint scale that relies on a maximum size.
                 *
                 * @since 0.0.2
                 */
                switch (true) {
                    // Medium range breakpoints
                    case width > 840 && width < 960:
                        breakpoint = 60;
                        break;
                    // Medium small range breakpoints
                    case width > 768 && width < 841:
                        breakpoint = 30;
                        break;
                    // Small range breakpoints
                    case width > 480 && width < 769:
                        breakpoint = 18;
                        break;
                    // Extra small range breakpoints
                    case width < 481:
                        breakpoint = 10;
                        break;
                }

                // Define our viewport size block
                var dims = {
                    w: width,
                    h: height,
                    b: breakpoint,
                    o: orientation
                };

                // Save a copy of the measurements in context
                p3.viewport.dimensions = dims;

                // Return our dimensions
                return p3.viewport.dimensions;
            },

            /**
             * Determine if the current viewport is considered "large".
             *
             * Generally, a "large" viewport is considered any size that is
             * greater than that of the standard tablet. Laptop and other
             * desktop computers qualify here.
             *
             * @since 0.0.8
             * @method isLarge
             * @return bool Flag indicating a "small" screen size
             */
            isLarge: function isLarge() {
                // Declare and initialize
                var dimensions = p3.viewport.dimensions || {};
                var breakpoint = dimensions.b || 100;

                // How small is the screen?
                return 100 === breakpoint;
            },

            /**
             * Determine if the current viewport is considered "medium".
             *
             * Generally, a "medium" viewport is considered any size that is of
             * greater dimensions than a large phone; about the size of a
             * tablet device or similar.
             *
             * @since 0.0.8
             * @method isMedium
             * @return bool Flag indicating a "small" screen size
             */
            isMedium: function isMedium() {
                // Declare and initialize
                var dimensions = p3.viewport.dimensions || {};
                var breakpoint = dimensions.b || 100;
                var threshold = 60;

                // How small is the screen?
                return threshold > breakpoint;
            },

            /**
             * Determine if the current viewport is considered "small".
             *
             * Generally, a "small" viewport is considered any size that is of
             * smaller dimensions than a standard desktop but larger than the
             * smallest phone sizes. iPad portrait, for instance, falls into
             * this category.
             *
             * @since 0.0.2
             * @method isSmall
             * @return bool Flag indicating a "small" screen size
             */
            isSmall: function isSmall() {
                // Declare and initialize
                var dimensions = p3.viewport.dimensions || {};
                var breakpoint = dimensions.b || 100;
                var threshold = 20;

                // How small is the screen?
                return threshold > breakpoint;
            },

            /**
             * Determine if the current viewport is considered "tiny'.
             *
             * Compounding the population of "small" viewports, what we would
             * consider to be "tiny" viewports constitutes primary of mobile
             * phone viewports and screens.
             *
             * @since 0.0.2
             * @method isTiny
             * @return bool Flag indicating a "tiny" sreen size
             */
            isTiny: function isTiny() {
                // Declare and initialize
                var dimensions = p3.viewport.dimensions || {};
                var breakpoint = dimensions.b || 100;
                var threshold = 15;

                // How tiny is the screen?
                return threshold > breakpoint;
            }
        },

        /**
         * Text manipulation utilities.
         *
         * There are a number of useful textual functions that are missing from
         * the vanilla javascript library. We solve two mysteries by defining
         * our own utility functions here: 1) we are able to fine-tune the
         * exact functionality of the text utility and 2) we can provide
         * our own controlled, specific verion of existing functions.
         *
         * @since 0.0.1
         * @package PhaseThree
         * @class text
         */
        text: {

            /**
             * Replace any links in a string with an HTML anchor.
             *
             * In situations where we want links to be clickable but only allow
             * plain text to be input, we can compromise and convert links to
             * clickable anchors.
             *
             * @since 0.1.1
             * @method anchor
             * @param string text The text to scan
             * @return Unchanged or anchored string
             */
            anchor: function anchor(text) {
                // We need a proper text string to continue
                if (!text || 'string' !== typeof text) return '';

                // Declare and initialize
                var template = '<a href="$1">$1</a>';
                var parts = [
                // Matches the beginning of the URL
                '(?:(?:ht|f)tps?:\/\/|www)',
                // Prevents matching shortcodes and HTML tags
                '[^<>\]]+?',
                // Preents matching URLs inside HTML tags
                '(?![^<>\]]*([>]|<\/))',
                // Tries to ascertain the end of the URL
                '(?=[\s!,?\]]|$)'].join('');

                // Compile the regex pattern from the parts
                var regex = new RegExp('/' + parts + '/', 'g');

                // Replace the string with anchors and return the result
                return text.replace(regex, template);
            },

            /**
             * Replace line breaks with the `<br />` element.
             *
             * When we go from the server to the frontend and back and forth,
             * we rely on a lot of validation and filtering. Because of the
             * way jQuery handles and injections, we often lose non-html
             * text that has line breaks in it. Big blocks of text are
             * ugly, especially if there is an entire article worth
             * of non-line-broken yuckiness. Let's break it up!
             *
             * @since 0.0.1
             * @method breakLines
             * @param string text Unbroken text that needs a breaking
             * @return string Processed HTML-based line breaking
             */
            breakLines: function breakLines(text) {
                // We need a proper text string to continue
                if (!text || 'string' !== typeof text) return '';

                // Divide and conquer
                var broken = '';

                // Iterate through our text
                text.split("\n").map(function (item, i) {
                    broken += '<span>' + item + '<br /></span>';
                });

                return broken;
            },

            /**
             * Convert HTML entities into normal people text.
             *
             * Most of the time we are going to be storing special characters as
             * entities in our database. For security reasons, a majority of
             * our frontend displays plaintext only. We use this tool to
             * convert the entities into strings.
             *
             * @since 0.1.1
             * @method decode
             * @param string html The html-encoded string we will decode
             * @return string Decoded standard text
             */
            decode: function decode(html) {
                // Create a fake element
                var ele = document.createElement('textarea');

                // Fill the element with our text
                ele.innerHTML = html;

                // Retrieve the text value
                var text = ele.value;

                // Destroy our element
                ele = null;

                // Return the text we found
                return text == null || text == 'null' ? '' : text;
            },

            /**
             * Generate a simple hash.
             *
             * When generating passwords or attempting to provide semi-unique
             * keys for processing, we use a simple has function that will
             * create a random string to serve as a hash.
             *
             * @since 0.1.0
             * @method hash
             * @param int len How long of a has do you want
             * @return string Random characters in a set-length string
             */
            hash: function hash(len) {
                // Never create too large of a string
                var len = Math.min(32, len);
                var set = 'acdefghjkmnpqrstuvwxyzACDEFGHJKMNPQRSTUVWXYZ2345679';
                var n = set.length;
                var val = '';

                // Iterate through our set and build up our hash
                for (var i = 0; i < len; ++i) {
                    val += set.charAt(Math.floor(Math.random() * n));
                }

                // Throw back the result
                return val;
            },

            /**
             * Decide on using the plural or singular version of a word.
             *
             * When we have some kind of counter and a complementary label of
             * some sort, we probably want to output the correct form of the
             * label based on the state of the counter.
             *
             * @since 0.5.0
             * @method inflect
             * @param int count How many of the thing there are
             * @param string single The singular version of the word
             * @param string plural The plural version of the word
             * @return string The correct inflection of the word
             */
            inflect: function inflect(count, single, plural) {
                // Return the correct inflection
                return count + ' ' + (1 === count ? single : plural);
            },

            /**
             * Generate a slug from a string.
             *
             * Slugs represent a human-readable representation of a string that
             * can be used to identify a resource. Where titles and content
             * may have spaces and special characters, slugs are always a
             * simple reduction of the string consisting of hyphens and
             * any lowercase alphanumeric characters.
             *
             * @sicne 0.1.1
             * @nethod slug
             * @param string str The string we will sluggify
             * @return string A slugged string
             */
            slug: function slug(str) {
                // Sluggify and return the string
                return (str || '').toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-');
            },

            /**
             * Truncate text to a specified length without clipping words.
             *
             * Snipping a string to fit into a mold is easy enough with native
             * functions, but often we want to be able to truncate the text
             * and still maintain legitimate words (e.g., excerpts of long
             * posts and whathaveyou).
             *
             * @since 0.0.8
             * @method truncate
             * @param string text Long string with which to process
             * @param int length The maximum length of truncated string
             * @return string Shortened version of strig with full words
             */
            truncate: function truncate(text, length) {
                // If string is already short enough, bail
                if (text.length < length) return text;

                // Trim the string to the longest possible length
                var short = text.substr(0, length + 1);

                // Trim again if we cut a word in half
                short.substr(0, Math.min(short.length, short.lastIndexOf(' ')));

                // Return the shortened string
                return short + '...';
            },

            /**
             * Remove a trailing slash if a trailing slash exists.
             *
             * When dealing with URLs, it is important to keep the formatting
             * consistent across the board to ease some unexpected routing
             * bugs. Having a '...view/100' versus a '...view/100/' may
             * not seem like much, but the looming threat of back-test
             * mayhem for all our URLs is enough to take action.
             *
             * @since 0.1.1
             * @method unslash
             * @param string url The URL that may or may not have a trail slash
             * @return string An unslashed URL string
             */
            unslash: function unslash(url) {
                // Remove trailling slashes and return the result
                return (url || '').replace(/\/+$/, '');
            }

        },

        /**
         * Validation rules for various user input fields.
         *
         * Rules for a successfuly validation are not likely to change between
         * similarly-categorized fields. When files are primed for upload, as
         * an example, we have to make sure they fall under the server rules
         * as specified in the configuration (non-empty, filetypes, etc.).
         *
         * @since 0.0.2
         * @package PhaseThree
         * @class validate
         */
        validate: {

            /**
             * Simple validation for properly-formatted email addresses.
             *
             * When we want to do a quick check to see whether a given string is
             * considered a valid email address, we just have to run it through
             * a lightweight regex pattern test. On the frontend, the most we
             * care about is that the user did not make a mistake somewhere.
             *
             * @since 0.0.7
             * @method email
             * @param string email The string to test
             * @return bool Flag indicating valid or invalid email address
             */
            email: function email(_email) {
                // Declare and initialize
                var pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                // Return the results of the test
                return pattern.test(_email);
            },

            /**
             * Make sure all of our custom field values are valid.
             *
             * Due to the increasing complexity of custom fields and constant
             * need for increased optimization, we relegate validation of
             * all fields to a single validator function.
             *
             * @since 0.0.7
             * @method fields
             * @param object sections The custom field set to test
             * @param object values The current field values
             * @return bool Flag indicating all valid fields
             */
            fields: function fields(sections, values) {
                // Declare and initialize
                var fields = sections || [];
                var halt = false;

                // Iterate through our custom fields looking for files
                for (var i in fields) {

                    // Declare and intialize
                    var atts = fields[i].atts || {};
                    var options = fields[i].options || [];
                    var required = 'on' === atts.required;
                    var initial = atts.value || atts.initial || '';
                    var id = 'field-' + fields[i].uid;
                    var value = values[id];
                    var type = fields[i].type || '';
                    var hasEmpty = 'on' === fields[i].empty;
                    var hasOptions = 0 < options.length;
                    var isSelect = 'select' == fields[i].type;
                    var isGroups = 'groups' == fields[i].type;

                    // Check if the values are all kosher
                    halt = required && !value && 0 !== value;

                    // If select option with empty, do not let it be 0
                    if (isSelect && hasEmpty && required) halt = hasOptions && 0 === value;

                    // If group field and required, do not let it be 0
                    if (isGroups && required) halt = hasOptions && 0 === value;

                    // Validate addresses differently
                    if (required && 'address' === type) {

                        // Declare and initialize
                        var restrict = 'on' === atts.street;

                        // Error on street restriction without street
                        if (restrict && (!value.street || !value.house)) return false;

                        // Error on no restriction without street address
                        if (!restrict && !value.street1) return false;

                        // Error on missing city, state, or zip
                        if (!value.city || !value.state || !value.zip) return false;
                    }

                    // If something does not smell right, stop everything
                    if (halt) return false;
                }

                // We made it this far: all clear
                return true;
            },

            /**
             * Validate the field values required for a given form
             *
             * A very quick run of validation just so there is some order in
             * filling out a form. Any `text` coming in needs to be filled
             * out and any `attachment` files need to be validated for
             * type and size and total limits.
             *
             * Setting a `require{Field}` property in the `values` parameter
             * will toggle validation for that particular field.
             *
             * @since 0.0.2
             * @method form
             * @param object values The form values with which to test
             * @param object handlers Collection of validation handler
             * @param string accept Acceptable file types
             * @return bool Validation results
             */
            form: function form(values, handlers, accept) {
                // Declare and initialize
                var globals = P3Globals || {};
                var handlers = handlers || {};
                var accept = accept || globals.filetypes;
                var text = values.text || '';
                var checkbox = values.checkbox;
                var attachment = values.attachment;
                var errorType = '';
                var aux = '';
                var isInvalid = false;
                var callback = handlers.callback;
                var require = {
                    text: values.requireText || false,
                    attachment: values.requireAttachment || false
                };
                var has = {
                    fail: 'function' === typeof handlers.fail,
                    flash: 'function' === typeof handlers.flash
                };

                // Handle required text validation
                if (require.text && (!text || '' === text.trim())) {
                    // Set our error details
                    isInvalid = true;

                    // Run the fail handler if we have it
                    if (has.fail) handlers.fail('no-content', null, callback);
                }

                // If attachments are required but empty, do something about it
                if (require.attachment && (!attachment || !attachment.length)) {
                    // Set our error details
                    isInvalid = true;
                    errorType = 'no-attachment';

                    // Run the fail handler if we have it
                    if (has.fail) handlers.fail(errorType, null, callback);
                }

                // Make sure we are only accepting valid files
                if (accept && attachment) {

                    // Assume they are out to get us
                    var validateFiles = p3.validate.file(attachment, accept);
                    var valid = validateFiles.valid || false;
                    errorType = validateFiles.errorType || errorType;
                    aux = validateFiles.aux || aux;

                    // Get out of here if there were invalid uploads
                    if (!valid) {
                        // Set our error details
                        isInvalid = true;

                        // Run the fail handler if we have it
                        if (has.fail) handlers.fail(errorType, aux, callback);
                    }
                }

                // Flash if we have a flash handler
                if (isInvalid && has.flash) {
                    handlers.flash({
                        message: 'There was a problem with your form values.'
                    });
                }

                // Let them know what we know
                return isInvalid;
            },

            /**
             * Make sure a potential upload is on the level.
             *
             * We do not want to be on the receiving end of unhandled exceptions
             * with file uploads. If we were expecting an image and a script is
             * uploaded without proper handling, we are doomed.
             *
             * @since 0.1.1
             * @method file
             * @param array files Collection of files to test
             * @return bool|string True on valid, error on fail
             */
            file: function file(files, accept) {

                // Declare and initialize
                var globals = P3Globals || {};
                var accept = accept || globals.filetypes;
                var maxFileLimit = globals.maxFileLimit;
                var maxFileSize = globals.maxFileSize;
                var maxTotalSize = globals.maxTotalSize;
                var totalSize = 0;
                var totalCount = 0;
                var errorType = '';
                var aux = '';
                var valid = false;

                // Iterate through our attachment fields
                for (var i in files) {

                    // Declare our attachment
                    var f = files[i];

                    // Ignore non-objects
                    if ('object' !== (typeof f === 'undefined' ? 'undefined' : _typeof(f))) continue;

                    // Increment our total file count
                    totalCount++;

                    // Check if we are under our file count limit
                    valid = maxFileLimit > totalCount;

                    // If the type is invalid, we can stop and leave
                    if (!valid) {
                        // Set the error type
                        errorType = 'file-too-many';
                        aux = maxFileLimit;

                        break;
                    }

                    // Check if the type is valid
                    valid = ~accept.indexOf(f.type);

                    // If the type is invalid, we can stop and leave
                    if (!valid) {
                        // Set the error type
                        errorType = 'invalid-file';

                        break;
                    }

                    // Check if the individual file size is under the limit
                    valid = f.size < maxFileSize;

                    // If the size is too large, we can stop and leave
                    if (!valid) {
                        // Set the error type
                        errorType = 'file-too-large';
                        aux = maxFileSize;

                        break;
                    }

                    // Accumulate our total file size
                    valid = maxTotalSize > (totalSize += f.size);

                    // If the total size too large, we can stop and leave
                    if (!valid) {
                        // Set the error type
                        errorType = 'files-too-large';
                        aux = maxTotalSize;

                        break;
                    }
                }

                // Return the results
                return {
                    valid: valid,
                    errorType: errorType,
                    aux: aux
                };
            },

            /**
             * Make sure values for file input are valid.
             *
             * Manage a number of different scenarios in which the file upload
             * validator returns as a failure.
             *
             * @since 0.0.2
             * @method message
             * @param int type The failure type
             * @param mixed aux Auxiliary data in providing failure response
             * @param function callback Optional error handling function
             * @param string exts The allowable extensions
             * @return void
             * @todo This needs to be a generalized function
             */
            message: function message(type, aux, callback, exts) {
                // Declare and initialize
                var globals = P3Globals || {};
                var validExts = exts || globals.fileexts || '';
                var error = '';

                // If error passed from async, process differently
                if ('object' === (typeof type === 'undefined' ? 'undefined' : _typeof(type))) {
                    error = type.error || { returned: 'Unknown Error' };
                    type = 'form-attachment-fail';
                }

                // Determin our specialized error type
                switch (type) {
                    case 'no-content':

                        // Load an error message for our form
                        error = 'This content cannot be blank.';
                        break;

                    case 'no-attachment':

                        // Load an error message for our form
                        error = 'You have to add at least one file to upload.';
                        break;

                    case 'invalid-file':

                        // Get our valid extensions
                        error = 'The following filetypes are valid: ' + validExts.replace(/,/g, ', ');
                        break;

                    case 'file-too-many':

                        // Get our valid extensions
                        error = 'The maximum number of files you can' + ' upload at a time is ' + aux + '.';
                        break;

                    case 'file-too-large':

                        // Get our valid extensions
                        error = 'One of your files is too large. The max ' + 'file size is: ' + p3.file.size(aux);
                        break;

                    case 'files-too-large':

                        // Get our valid extensions
                        error = 'The size of all of your files is too ' + 'large. The max total file size is: ' + p3.file.size(aux);
                        break;
                }

                // If we have a callback defined, run it
                if ('function' === typeof callback) callback(error);

                // Throw back the error
                return error;
            }
        },

        /**
         * Prepend the site URL to a given path.
         *
         * The cornerstone of any frontend navigation system is the ability to
         * reliably create URLs regardless of the type, content, and depth
         * of a page, relative to the site. This is especially true in a
         * multisite environment where routing is managed by our host
         * framework. Here we are able to extract URI information
         * localized by the server to generate URLs.
         *
         * @since 0.0.1
         * @method url
         * @param string path The URL parameters to append
         * @param bool useSiteUrl Flag to use site URL instead of portal URL
         * @return string The fully-generated URL
         */
        url: function url(path, useSiteUrl) {
            // Declare and initializei
            var domain = useSiteUrl ? p3.siteUrl : p3.domain || '/';
            var url = domain + path;

            // Return the compound URL
            return url;
        },

        /**
         * Color and consistent console logging wrapper.
         *
         * Basically a wrapper function for the console log that fills in and
         * translates the message and color of the data being passed through.
         * This method takes in a message and an (optional) color and then
         * proceeds to translate to a console log with the parameters.
         *
         * @since 0.0.1
         * @method log
         * @param string|mixed message The message to log
         * @param string tag Category representation of a log entry
         * @param string color The color to paint the message
         * @return void
         */
        log: function log(message, tag, color) {

            // Rhinox Maximize!
            var self = this;
            var raw = message;

            // We will not show console logs during development
            if (!debug) return;

            // If we had a timer, do some special processing
            if ('timer' === tag) {

                // Set some default tag for colorization
                tag = 'log';

                // Calculate the time in seconds (we receive milliseconds
                var time = parseFloat((message / 1000).toFixed(3));

                // Define our own timer message
                message = 'Took ' + time + 's.';
            }

            // Manage our log entry parts
            message = message || '[Error] An unknown action has occurred.';

            // Default to a tag if one is missing
            if (!tag) tag = 'log';

            // Aply the tag to the message
            message = '[' + tag + '] ' + message;

            // Try to color code all of our tags uniformly
            if (!color && tag) color = p3._logTagColor(tag);

            // Declare and initialize
            var log = '%c ' + message;
            var style = 'color: #' + color + '; text-transform: capitalize;';

            // Formulate debug logs a bit differently
            if ('debug' === tag) {
                console.trace('%c [Debug] ', style, raw);
                return;
            }

            // Call up our console (use color if one was set)
            // Note: We used to do `console.trace` here but Chrome bugged
            if ('function' === typeof console.groupCollapsed && 'function' === typeof console.trace && 'function' === typeof console.groupEnd) {

                // Store our trace in a collapsed group
                console.groupCollapsed(log, style);
                console.trace('...');
                console.groupEnd();
            } else {

                // Normal, dumb log
                console.log(log, style);
            }
        },

        /**
         * Record of console log colors for various types of logs.
         *
         * In an effort to keep all of our console log type colors uniform, we
         * store some of the more common categories here and reference them
         * as needed. These colors are only requested when a log is called
         * without a color being deliberately set. The palette is derived
         * from the Material Design color palette.
         *
         * @since 0.0.1
         * @method logTagColor
         * @param string tag The tag to cross-reference
         * @return string The hex color value (without "#")
         */
        _logTagColor: function _logTagColor(tag) {
            // Declare and initialize
            var colors = {
                state: '00bcd6',
                upload: '009788',
                success: '48b04b',
                log: '89c541',
                init: 'cdde20',
                cancel: 'ffed18',
                skip: 'ffc200',
                editor: 'ff9900',
                debug: '7a5547',
                focus: '5f7d8c',
                permit: '9e9e9e',
                image: 'ff5607',
                fail: 'f7412d',
                file: 'ec1261',
                misc: '9d1cb2',
                ajax: '3f51b5',
                save: '6734ba',
                click: '3f4eb8',
                form: '1194f6',
                change: '00a7f7'
            };

            if (tag in colors) return colors[tag];
        },

        /**
         * Generate a random color.
         *
         * Sometimes you just want to generate a random color to brighten up
         * your day. There really was not even an interested in this method
         * until a minute amount of research was done and we established
         * it could be accomplished in one beautiful line of code that
         * some smart people were able to devise. It works by finding
         * a random number between 0 (000000) and 16777215 (ffffff)
         * and converting it to a string.
         *
         * @since 0.0.1
         * @method color
         * @return string Random hex color
         * @link https://www.paulirish.com/2009/random-hex-color-code-snippets/
         */
        color: function color() {
            // Generate the color
            var color = Math.floor(Math.random() * 16777215).toString(16);

            // Throw back the color (we always need 6)
            return ('c33d3d' + color).slice(-6);
        }
    };

    /**
     * Define constants.
     *
     * Since we are using immutable context objects in the application, we have
     * to define some constants that we use internally.
     *
     * @since 0.0.2
     */
    var p3 = _extends({}, $.PhaseThree);
    var getClassName = p3.object.getClassName;
    var logger = p3.log;
    var mailer = p3.mail;
    var debug = p3.debug;
})(_jquery2.default);


//////////////////
// WEBPACK FOOTER
// ./src/p3.js
// module id = 226
// module chunks = 7